module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_vm._m(0), _vm._v(" "), _c('strong', [_vm._v("Copyright © " + _vm._s((new Date()).getFullYear()) + " - "), _c('a', {
    attrs: {
      "href": "http://www.fbb.org.br"
    }
  }, [_vm._v("Fundação Banco do Brasil")]), _vm._v(".")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right hidden-xs"
  }, [_c('b', [_vm._v("Versão")]), _vm._v(" 3.1.3\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78ee93d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Footer.vue
// module id = 2029
// module chunks = 1